module.exports = __webpack_public_path__ + "img/image51.6d6d031b.png";